"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constants = require("./constants");

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

(function () {
  var styles = "@font-face {\n  font-family: 'OpenSansRegular';\n  src: url(\"../assets/font/OpenSans-latin-normal.woff2\") format(\"woff2\"); }\n\n.bds-vertical-tabs-ul-list {\n  display: flex;\n  flex-direction: column;\n  list-style: none;\n  box-sizing: border-box;\n  height: 100%;\n  padding: 0;\n  margin: 0;\n  overflow: hidden;\n  border-right: 0.125rem solid #a8a8a8; }\n  .bds-vertical-tabs-ul-list:hover {\n    overflow-y: auto; }\n\n.bds-vertical-li {\n  display: flex;\n  cursor: pointer;\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n  padding-left: 1.5rem;\n  padding-right: 1rem; }\n  .bds-vertical-li:hover {\n    background-color: #e0e0e0; }\n\n.bds-selected-vertical-li {\n  padding-left: 1.375rem;\n  background-color: #d0e2ff;\n  border-left: 0.125rem solid #067fdb; }\n\n.bds-vertical-li-with-icon {\n  display: flex;\n  cursor: pointer;\n  padding-top: 0.9375rem;\n  padding-bottom: 0.9375rem;\n  padding-left: 1rem;\n  padding-right: 1rem; }\n  .bds-vertical-li-with-icon:hover {\n    background-color: #e0e0e0; }\n\n.bds-selected-vertical-li-with-icon {\n  padding-left: 0.875rem;\n  background-color: #d0e2ff;\n  border-left: 0.125rem solid #067fdb; }\n\n.bds-vertical-tab-container {\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  width: 100%; }\n\n.bds-vertical-tab-title {\n  font-family: \"OpenSansRegular\";\n  font-size: 1rem;\n  font-weight: 600;\n  color: #525252;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis; }\n\n.bds-selected-vertical-tab-title {\n  color: #393939; }\n\n.bds-vertical-tab-icon-container {\n  display: flex;\n  align-items: center;\n  padding-right: 0.5rem;\n  justify-content: center;\n  color: #6f6f6f; }\n\n.bds-vertical-tabs-ul-list::-webkit-scrollbar {\n  width: 0.5rem; }\n\n.bds-vertical-tabs-ul-list::-webkit-scrollbar-track {\n  border-radius: 0.5rem; }\n\n.bds-vertical-tabs-ul-list::-webkit-scrollbar-thumb {\n  border-radius: 0.5rem;\n  background-color: #c6c6c6; }\n\n.bds-vertical-tabs-ul-list::-webkit-scrollbar-thumb:hover {\n  background-color: #6f6f6f; }\n\n.bds-vertical-tabs-ul-list::-webkit-scrollbar-track-piece:start {\n  background: transparent; }\n\n.bds-vertical-tabs-ul-list::-webkit-scrollbar-track-piece:end {\n  background: transparent; }\n";
  var fileName = "compone_verticaltabs";
  var element = document.querySelector("style[data-sass-component='compone_verticaltabs']");

  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();

var VerticalTabs = function VerticalTabs(_ref) {
  var value = _ref.value,
      handleChange = _ref.handleChange,
      items = _ref.items,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? _constants.defaultTabsWidth : _ref$width,
      _ref$topPadding = _ref.topPadding,
      topPadding = _ref$topPadding === void 0 ? _constants.defaultTopPadding : _ref$topPadding;

  var tabClickHandler = function tabClickHandler(index) {
    handleChange(index);
  };

  var ulClasses = _defineProperty({}, _constants.classes.verticalTabsUlList, true);

  return /*#__PURE__*/_react.default.createElement("ul", {
    style: {
      width: width,
      paddingTop: topPadding
    },
    className: (0, _classnames.default)(_objectSpread({}, ulClasses)),
    tabIndex: _constants.defaultTabIndex
  }, items && items.length && items.map(function (element, index) {
    var isSelected = index === value ? true : false;
    return /*#__PURE__*/_react.default.createElement(Tab, {
      itemIndex: index,
      key: "".concat(_constants.tabKeyPrefix).concat(index),
      isSelected: isSelected,
      title: element.title,
      icon: element.icon,
      tabClickHandler: tabClickHandler
    });
  }));
};

var Tab = function Tab(_ref2) {
  var _liClasses, _tabTitleClasses;

  var title = _ref2.title,
      isSelected = _ref2.isSelected,
      tabClickHandler = _ref2.tabClickHandler,
      itemIndex = _ref2.itemIndex,
      icon = _ref2.icon;
  var liClasses = (_liClasses = {}, _defineProperty(_liClasses, _constants.classes.verticalLi, true && !Boolean(icon)), _defineProperty(_liClasses, _constants.classes.selectedVerticalLi, isSelected && !Boolean(icon)), _defineProperty(_liClasses, _constants.classes.verticalLiWithIcon, Boolean(icon)), _defineProperty(_liClasses, _constants.classes.selectedVerticalLiWithIcon, Boolean(icon) && isSelected), _liClasses);
  var tabTitleClasses = (_tabTitleClasses = {}, _defineProperty(_tabTitleClasses, _constants.classes.verticalTabTitle, true), _defineProperty(_tabTitleClasses, _constants.classes.selectedVerticalTabTitle, isSelected), _tabTitleClasses);
  return /*#__PURE__*/_react.default.createElement("li", {
    tabIndex: _constants.defaultTabIndex,
    className: (0, _classnames.default)(_objectSpread({}, liClasses)),
    onClick: function onClick() {
      return tabClickHandler(itemIndex);
    },
    title: title
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.verticalTabContainer
  }, icon && /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.verticalTabIconContainer
  }, icon), title && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_objectSpread({}, tabTitleClasses))
  }, title)));
};

VerticalTabs.propTypes = {
  value: _propTypes.default.number.isRequired,
  handleChange: _propTypes.default.func.isRequired,
  items: _propTypes.default.array.isRequired,
  width: _propTypes.default.string,
  topPadding: _propTypes.default.string
};
var _default = VerticalTabs;
exports.default = _default;